'use client';

import { useEffect } from 'react';

/**
 * Só um service worker controla o escopo `/`. Com o `sw.js` (cache Workbox) e o `abfpush-sw.js`
 * (push) registrados juntos, um substituía o outro a cada visita. O `sw.js` fica desligado:
 * registrar só o push já troca o `sw.js` de quem ainda o tinha ativo.
 * `NEXT_PUBLIC_WORKBOX_SW=true` volta a registrá-lo como antes.
 */
const WORKBOX_SW_ENABLED = process.env.NEXT_PUBLIC_WORKBOX_SW === 'true';

/** Caches criados pelo `public/sw.js`; sem ele ninguém mais os lê nem expira. */
const WORKBOX_CACHE_NAMES = [
  'static-images',
  'api-cache',
  'wp-theme-files',
  'wp-plugin-files',
  'wp-uploads',
  'css-cache',
  'js-cache',
  'html-cache',
  'font-cache',
  'image-cache',
];

export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      if (WORKBOX_SW_ENABLED) {
        navigator.serviceWorker
          .register('/sw.js?v=cf-2', { scope: '/' })
          .then((registration) => {
            setInterval(() => {
              registration.update();
            }, 60 * 60 * 1000);
          })
          .catch((error) => {
            console.error('Erro ao registrar Service Worker:', error);
          });
      } else if ('caches' in window) {
        caches
          .keys()
          .then((keys) =>
            Promise.all(
              keys.filter((key) => WORKBOX_CACHE_NAMES.includes(key)).map((key) => caches.delete(key))
            )
          )
          .catch(() => {});
      }

      navigator.serviceWorker
        .register('/abfpush-sw.js?v=analyticspub-1', { scope: '/' })
        .then(() => {})
        .catch((error) => {
          console.warn('Erro ao registrar AbfPush Service Worker:', error);
        });
    }
  }, []);

  return null;
}
